import { Typography } from "@mui/material";
import { Box } from "@mui/system";

import login_utilies_app from "../images/faq/login_utilies_app.png"
import landing_utilies_app from "../images/faq/landing_utilities_app.png"
import tabs_utilies_app from "../images/faq/tabs_utilities_app.png"
import add_reading_utilies_app from "../images/faq/add_reading_utilities_app.png"
import enter_reading_utilies_app from "../images/faq/enter_reading_utilities_app.png"
import save_reading_utilies_app from "../images/faq/save_reading_utilities_app.png"
import see_all_meters_utilies_app from "../images/faq/see_all_meters_utilities_app.png"
import search_meters_utilies_app from "../images/faq/search_meters_utilities_app.png"
import sort_meters_utilies_app from "../images/faq/sort_meters_utilities_app.png"
import offline_mode_utilities_app from "../images/faq/offline_mode_utilities_app.png"
import offline_mode_syncing_utilities_app from "../images/faq/offline_mode_syncing_utilities_app.png"
import report_broken_meter_utilities_app from "../images/faq/report_broken_meter_utilities_app.png"
import confirm_report_broken_meter_utilies_app from "../images/faq/confirm_report_broken_meter_utilies_app.png"


import add_a_vendor from "../images/faq/add_a_vendor.png";

import new_ui_complexes_menu from "../images/new_ui_faq/menu_select_complexes.png";
import new_ui_complexes_menu_hoa from "../images/new_ui_faq/menu_select_complexes_hoa.png";
import new_ui_properties_menu from "../images/new_ui_faq/menu_select_properties.png";
import new_ui_properties_menu_hoa from "../images/new_ui_faq/menu_select_properties_hoa.png";
import new_ui_report_menu from "../images/new_ui_faq/menu_select_report.png";
import new_ui_assets_menu from "../images/new_ui_faq/menu_select_assets.png";
import new_ui_meters_menu from "../images/new_ui_faq/menu_select_meters.png";
import new_ui_meters_menu_hoa from "../images/new_ui_faq/menu_select_meters_hoa.png";
import new_ui_leases_menu from "../images/new_ui_faq/menu_select_leases.png";
import new_ui_select_tenant_menu from "../images/new_ui_faq/menu_select_tenant.png";
import new_ui_messages_menu from "../images/new_ui_faq/menu_select_messages.png";
import new_ui_select_user_menu from "../images/new_ui_faq/menu_select_user.png";
import new_ui_select_meter_menu from "../images/new_ui_faq/meter_select_menu.png";
import new_ui_select_meter_menu_hoa from "../images/new_ui_faq/meter_select_menu_hoa.png";
import new_ui_select_invoice_menu from "../images/new_ui_faq/select_invoice_menu.png";
import new_ui_select_receipt_menu from "../images/new_ui_faq/select_receipt_menu.png";
import new_ui_bills_payment_menu from "../images/new_ui_faq/bills_payment_menu.png";
import new_ui_menu_work_order from "../images/new_ui_faq/menu_work_order.png";
import new_ui_menu_vendor from "../images/new_ui_faq/menu_vendor.png";

import new_ui_create_complexes_button from "../images/new_ui_faq/create_complex_button.png";
import new_ui_create_complexes_modal from "../images/new_ui_faq/create_complex_modal.png";
import new_ui_create_unit_button from "../images/new_ui_faq/create_unit_button.png";
import new_ui_create_unit_modal from "../images/new_ui_faq/create_unit_modal.png";
import new_ui_create_asset_modal from "../images/new_ui_faq/create_asset_modal.png";
import new_ui_create_lease_modal from "../images/new_ui_faq/create_lease_modal.png";
import new_ui_assets_edit_maintenance_modal from "../images/new_ui_faq/edit_asset_maintenance_modal.png";
import new_ui_terminate_lease_modal from "../images/new_ui_faq/terminate_lease_maintenance_modal.png";
import new_ui_meter_edit_modal from "../images/new_ui_faq/meter_edit_modal.png";
import new_ui_work_order_edit_modal from "../images/new_ui_faq/work_order_edit_modal.png";

import new_ui_edit_unit_modal from "../images/new_ui_faq/edit_unit_modal.png";
import new_ui_generate_report_modal from "../images/new_ui_faq/generate_report_modal.png";

import new_ui_meters_add_meter_readings_modal from "../images/new_ui_faq/meter_add_meter_reading_modal.png";
import new_ui_edit_lease_modal from "../images/new_ui_faq/edit_lease_modal.png";
import new_ui_page_edit_tenant_modal from "../images/new_ui_faq/edit_tenant_modal.png";
import new_ui_personOrg_search_modal from "../images/new_ui_faq/personOrg_search_modal.png";
import new_ui_personOrg_search_results_modal from "../images/new_ui_faq/personOrg_search_results_modal.png";
import new_ui_personOrg_search_no_results_modal from "../images/new_ui_faq/personOrg_search_no_results_modal.png";
import new_ui_add_user_pre_populated_modal from "../images/new_ui_faq/add_user_pre_populated_modal.png";
import new_ui_add_user_modal from "../images/new_ui_faq/add_user_modal.png";
import new_ui_edit_user_modal from "../images/new_ui_faq/edit_user_modal.png";
import new_ui_delete_user_modal from "../images/new_ui_faq/delete_user_modal.png";
import new_ui_meter_add_modal from "../images/new_ui_faq/meter_add_modal.png";
import new_ui_receipt_charge_modal from "../images/new_ui_faq/receipt_charge_modal.png";
import new_ui_lease_add_charge_modal from "../images/new_ui_faq/lease_add_charge_modal.png";
import new_ui_lease_add_credit_modal from "../images/new_ui_faq/lease_add_credit_modal.png";
import new_ui_vendor_add_vendor_modal from "../images/new_ui_faq/vendor_add_vendor_modal.png";
import new_ui_add_vendor_results_modal from "../images/new_ui_faq/add_vendor_results_modal.png";
import new_ui_add_vendor_no_results_modal from "../images/new_ui_faq/add_vendor_no_results_modal.png";
import new_ui_add_vendor_individual_modal from "../images/new_ui_faq/add_vendor_individual_modal.png";
import new_ui_add_vendor_company_modal from "../images/new_ui_faq/add_vendor_company_modal.png";

import new_ui_datagrids_property_units from "../images/new_ui_faq/datagrids_property_units.png";
import new_ui_datagrids_property_units_edit from "../images/new_ui_faq/datagrids_property_units_edit.png";

import new_ui_datagrids_leases_terminate from "../images/new_ui_faq/datagrids_leases_terminate.png";
import new_ui_datagrids_leases_edit from "../images/new_ui_faq/datagrids_leases_edit.png";
import new_ui_page_datagrid_tenant_edit from "../images/new_ui_faq/datagrids_tenant_edit.png";
import new_ui_datagrid_lease_view from "../images/new_ui_faq/datagrids_lease_view.png";
import new_ui_datagrid_meter_edit from "../images/new_ui_faq/datagrid_meter_edit.png";
import new_ui_datagrid_receipt_void from "../images/new_ui_faq/datagrid_receipt_void.png";
import new_ui_datagrid_leases_charge from "../images/new_ui_faq/datagrid_leases_charge.png";
import new_ui_datagrid_leases_credit from "../images/new_ui_faq/datagrid_leases_credit.png";
import new_ui_datagrid_work_order_edit from "../images/new_ui_faq/datagrid_work_order_edit.png";

import new_ui_page_assets from "../images/new_ui_faq/page_assets.png";
import new_ui_page_leases from "../images/new_ui_faq/page_leases.png";
import new_ui_page_tenant from "../images/new_ui_faq/page_tenant.png";
import new_ui_lease_detail_page from "../images/new_ui_faq/page_lease_view.png";
import new_ui_page_messages from "../images/new_ui_faq/page_messages.png";
import new_ui_page_user from "../images/new_ui_faq/page_user.png";
import new_ui_page_meter from "../images/new_ui_faq/page_meter.png";
import new_ui_page_receipt from "../images/new_ui_faq/page_receipt.png";
import new_ui_page_work_order from "../images/new_ui_faq/page_work_order.png";
import new_ui_page_vendors from "../images/new_ui_faq/page_vendors.png";

import new_ui_ownerships_list_view from "../images/new_ui_faq/ownerships_view.png"
import new_ui_ownership_details from "../images/new_ui_faq/ownership_form.png"
import new_ui_ownership_company_search from "../images/new_ui_faq/ownership_company_search.png"
import new_ui_ownership_individual_search from "../images/new_ui_faq/ownership_individual_search.png"
import new_ui_ownership_add_charge from "../images/new_ui_faq/owenership_charges_add_row.png"
import new_ui_ownership_terminate from "../images/new_ui_faq/ownership_terminate.png"
import new_ui_ownership_add_note from "../images/new_ui_faq/ownership_add_note.png"
import new_ui_ownership_capitalfund_actions from "../images/new_ui_faq/ownership_capitalfund_actions.png"
import new_ui_ownership_capitalfund_buttons from "../images/new_ui_faq/ownership_capitalfund_buttons.png"
import new_ui_ownership_capitalfund_modal from "../images/new_ui_faq/ownership_capitalfund_modal.png"
import new_ui_ownership_add_budget_income from "../images/new_ui_faq/ownership_add_budget_income.png"
import new_ui_ownership_add_budget_modal from "../images/new_ui_faq/ownership_add_budget_modal.png"
import new_ui_ownership_add_budget_button from "../images/new_ui_faq/ownership_add_budget_button.png"
import new_ui_edit_homeowner_link from "../images/new_ui_faq/ownership_edit_home_owner.png"
import new_ui_edit_homeowner_modal from "../images/new_ui_faq/ownership_edit_home_owner_modal.png"
import new_ui_ownership_terminated_link from "../images/new_ui_faq/ownership_terminated_link.png"
import new_ui_ownership_terminated_view from "../images/new_ui_faq/ownership_terminated_view.png"
import new_ui_ownership_terminated_view_button from "../images/new_ui_faq/ownership_terminated_view_button.png"
import new_ui_ownership_receive_payment from "../images/new_ui_faq/ownership_receive_payment.png"
import new_ui_ownership_receive_payment_modal from "../images/new_ui_faq/ownership_receive_payment_modal.png"
import new_ui_ownership_issue_charge_credit from "../images/new_ui_faq/ownership_issue_charge.png"
import new_ui_ownership_add_note_input from "../images/new_ui_faq/ownership_add_note_input.png"
import new_ui_ownership_terminate_confirm from "../images/new_ui_faq/ownership_terminate_confirm.png"
import new_ui_ownership_terminate_add_row from "../images/new_ui_faq/ownership_terminate_confirm_add_row.png"

import new_ui_card_lease_document from "../images/new_ui_faq/card_lease_document.png";
import new_ui_card_user_edit from "../images/new_ui_faq/card_user_edit.png";
import new_ui_card_user_delete from "../images/new_ui_faq/card_user_delete.png";

import new_ui_form_messages_create from "../images/new_ui_faq/form_messages_create.png";

// New Accounting FAQ Images
// Banking & Transfers
import new_ui_accounting_bank_accounts from "../images/new_ui_faq/accounting_faq/accounting_faq_bank_accounts.png";
import new_ui_accounting_bank_accounts_view_add from "../images/new_ui_faq/accounting_faq/accounting_faq_bank_accounts_view_add.png";
import new_ui_accounting_bank_transfers from "../images/new_ui_faq/accounting_faq/accounting_faq_bank_transfers.png";
import new_ui_accounting_cash_to_bank_transfer from "../images/new_ui_faq/accounting_faq/accounting_faq_cash_to_bank_transfer.png";
import new_ui_accounting_cash_to_bank_transfer_details from "../images/new_ui_faq/accounting_faq/accounting_faq_cash_to_bank_transfer_details.png";
import new_ui_accounting_make_transfer_button from "../images/new_ui_faq/accounting_faq/accounting_faq_make_transfer_button.png";

// Enhanced Bills & Payments - Updated imports for create bill section
import new_ui_accounting_bills_payment_1 from "../images/new_ui_faq/accounting_faq/accounting_faq_create_bill_and_payment_1.png";
import new_ui_accounting_bills_payment_2 from "../images/new_ui_faq/accounting_faq/accounting_faq_create_bill_and_payment_2.png";
import new_ui_accounting_page_bills_payments from "../images/new_ui_faq/accounting_faq/accounting_faq_create_bill_and_payment_1.png";
import new_ui_accounting_add_bills_modal from "../images/new_ui_faq/accounting_faq/accounting_faq_add_bill_modal.png";
import new_ui_accounting_make_payment_modal from "../images/new_ui_faq/accounting_faq/accounting_faq_make_payment_modal.png";
import new_ui_accounting_populate_payment_info from "../images/new_ui_faq/accounting_faq/accounting_faq_populate_payment_info.png";
import new_ui_accounting_payments_tabbed_view from "../images/new_ui_faq/accounting_faq/accounting_faq_payments_tabbed_view.png";

// New Features
import new_ui_accounting_journal_entries_nav from "../images/new_ui_faq/accounting_faq/accounting_faq_journal_entries_nav.png";
import new_ui_accounting_manage_view_entries from "../images/new_ui_faq/accounting_faq/accounting_faq_manage_or_view_entries.png";
import new_ui_accounting_petty_cash_nav from "../images/new_ui_faq/accounting_faq/accounting_faq_petty_cash_nav.png";
import new_ui_accounting_petty_cash_top_ups from "../images/new_ui_faq/accounting_faq/accounting_faqs_petty_cash_top_ups.png";
import new_ui_accounting_taxes_1 from "../images/new_ui_faq/accounting_faq/accounting_faq_taxes_1.png";
import new_ui_accounting_taxes_nav from "../images/new_ui_faq/accounting_faq/accounting_faq_taxes_nav.png";
import new_ui_accounting_taxes_add_payments from "../images/new_ui_faq/accounting_faq/accounting_faq_taxes_add_payments.png";

// Enhanced Receipts & Invoices
import new_ui_accounting_invoice_search from "../images/new_ui_faq/accounting_faq/accounting_faq_invoice_search_2.png";
import new_ui_accounting_invoice_table from "../images/new_ui_faq/accounting_faq/accounting_faq_invoice_table_3.png";
import new_ui_accounting_receipt_search from "../images/new_ui_faq/accounting_faq/accounting_faq_receipt_search.png";
import new_ui_accounting_receipt_search_1 from "../images/new_ui_faq/accounting_faq/accounting_faq_receipt_search_1.png";
import new_ui_accounting_receipt_table from "../images/new_ui_faq/accounting_faq/accounting_faq_receipt_table.png";
import new_ui_accounting_desired_receipt from "../images/new_ui_faq/accounting_faq/accounting_faq_desired_receipt.png";

// Reconciliation
import new_ui_accounting_reconciliation from "../images/new_ui_faq/accounting_faq/accounting_faq_reconcilliation.png";
import new_ui_accounting_add_reconciliation from "../images/new_ui_faq/accounting_faq/accounting_faq_add_reconcilliation.png";
import new_ui_accounting_add_reconciliation_row from "../images/new_ui_faq/accounting_faq/accounting_faq_add_reconcilliation_row.png";
import new_ui_accounting_select_transactions from "../images/new_ui_faq/accounting_faq/accounting_faq_transactions_nav_1.png";

// Credit/Debit Notes
import new_ui_accounting_credit_debit_note_nav from "../images/new_ui_faq/accounting_faq/accounting_faq_credit_debit_note_nav.png";
import new_ui_accounting_credit_note from "../images/new_ui_faq/accounting_faq/accounting_faq_credit_note.png";
import new_ui_accounting_credit_note_table from "../images/new_ui_faq/accounting_faq/accounting_faq_credit_note_table.png";
import new_ui_accounting_debit_note from "../images/new_ui_faq/accounting_faq/accounting_faq_debit_note.png";
import new_ui_accounting_debit_note_table from "../images/new_ui_faq/accounting_faq/accounting_faq_dedit_note_table.png";
import new_ui_accounting_faq_receipt_nav_4 from "../images/new_ui_faq/accounting_faq/accounting_faq_receipt_nav_4.png";

import view_owned_units from "../images/faq/view_owned_units.png"
import view_single_unit_owned from "../images/faq/view_single_unit_owned.png"
import print_ownership_statement from "../images/faq/print_ownership_statement.png"
import load_more_transactions from "../images/faq/load_more_transactions.png"
import transaction_history from "../images/faq/transaction_history.png"
import documents_upload from "../images/faq/documents_upload.png"
import view_ownership_tenants from "../images/faq/view_ownership_tenants.png"
import properties_linked_to_ownership_units from "../images/faq/properties_linked_to_ownership_units.png"
import home_owners_capital_fund_approval from "../images/faq/home_owners_capital_fund_approval.png"


import { ResponsiveRow } from "../constants/layout.constants";
import kodi_theme from "../themes/kodiThemeProvider";

export default class FaqLoader {
  constructor() {
    this.faqData = [
      {
        name: "property",
        text: "Property",
        permitted: "BLDIR,BLDMG,REC,ACC,CS,OWN",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            hasSubAnswers: false,
            hasSteps: false,
            hasDescription: true,
            questionID: 1,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            question: "What is a Complex",
            answer: "A complex is a group of buildings that contain apartments or offices and are managed by the same company. In general, a group of properties.",
          },
          {
            hasSubAnswers: false,
            questionID: 2,
            question: "How do you add a complex?",
            hasDescription: true,
            answer: `This guide will walk you through the steps of how to add a complex in the SmartKodi system.`,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Homes / Rentals item in the navigation menu`,
              `2. Click on the Complex item on the dropdown. This will take you to the Complexes page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_complexes_menu}
                      alt="select complexes submenu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_complexes_menu_hoa}
                      alt="select complexes submenu hoa"
                    />
                  </ResponsiveRow>
                );
              },

              `3. Click the ADD COMPLEX button. This will take you to the “Create Complex” popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_create_complexes_button}
                      alt="new ui create complexes button"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_create_complexes_modal}
                      alt="new ui create complexes modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Populate the new complex information in the fields and “Select associated property(ies)” if any, input address information, or any additional details**.`,
              `5. Click the CREATE button to add the complex, or the CLOSE button to cancel and leave the page.`,
            ],
          },
          {
            questionID: 3,
            question: "How do you add/edit/delete a unit?",
            hasSubAnswers: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            subAnswers: [
              {
                header: "Add Unit",
                steps: [
                  `1. Once logged in, click on the Homes / Rentals item in the navigation menu`,
                  `2. Click on the Properties item on the dropdown`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_properties_menu}
                          alt="select properties submenu"
                        />
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_properties_menu_hoa}
                          alt="select properties submenu hoa"
                        />
                      </ResponsiveRow>
                    );
                  },
                  `3. Click on the UNIT ACTIONS button`,
                  `4. Click the ADD UNIT item from the dropdown. This will take you to the “Add Unit” popup modal.`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_create_unit_button}
                          alt="create unit button"
                        />
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_create_unit_modal}
                          alt="_creat _uni _modal"
                        />
                      </ResponsiveRow>
                    );
                  },
                  `5. Populate the unit details in the fields provided.`,
                  `6. Click the CREATE button to add the complex, or the CLOSE button to cancel.`,
                ],
              },
              {
                header: "Edit Unit",
                steps: [
                  `1. Once logged in, click on the Homes / Rentals item in the navigation menu and click on the Properties item on the dropdown, as illustrated in the 'Add Unit' tutorial.`,
                  `2. Scroll to the units table at the bottom of the page.`,
                  `3. Click on the unit's ACTIONS (the three-dot icon) button of the unit you'd like to edit. Then select the EDIT UNIT item on the dropdown menu`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_datagrids_property_units}
                          alt="datagrids property units "
                        />
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_datagrids_property_units_edit}
                          alt="datagrids property units edit"
                        />
                      </ResponsiveRow>
                    );
                  },
                  `4. This will take you to the Edit Unit” popup modal.`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={new_ui_edit_unit_modal}
                          alt="edit unit modal"
                        />
                      </ResponsiveRow>
                    );
                  },
                  `5. Edit the necessary unit details in the fields provided.`,
                  `6.Click the UPDATE button to add the complex, or the CLOSE button to cancel.`,
                ],
              },
            ],
          },
          {
            questionID: 49,
            question: "How do I view properties associated with my units?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              `Click on the properties icon to see the list of properties where your units are located.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={properties_linked_to_ownership_units}
                      alt="Properties linked to ownership units"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 4,
            question: "How can I view units that I own?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              '1. Navigate to the "My Home" section to see the list of units you own.',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={view_owned_units}
                      alt="View Units you own"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 44,
            question: "How do I print my Ownership Statement?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              '1. Click on "My Home".',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={view_owned_units}
                      alt="View Units you own"
                    />
                  </ResponsiveRow>
                )
              },
              `2. On the unit you want to view, click the 3-dot menu and select "View."`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={view_single_unit_owned}
                      alt="View A single Unit"
                    />
                  </ResponsiveRow>
                )
              },
              `3. Select the statement year then click on "Print Ownership Statement" to generate a pdf statement."`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={print_ownership_statement}
                      alt="Print ownership statement"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 45,
            question: "Can I print my ownership details?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              "Yes",
              '1. Navigate to "My Homes"',
              '2. Select the home click "View"',
              '3. Click on "Print Ownership" to access your ownership information.',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={print_ownership_statement}
                      alt="Print ownership statment"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 50,
            question: "How can I upload relevant documents?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              '1. Navigate to "My Homes"',
              '2. Select the home click "View"',
              '3. Click on "Select or drag and drop files.',
              '4. Click the "Upload" button to save the documents',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={documents_upload}
                      alt="Documents upload"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
        ],
      },
      {
        name: "reports",
        text: "Reports",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 5,
            question: "What types of reports are available?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [`1. Balance Sheet`, `2. Profit & Loss Statement`],
          },
          {
            questionID: 6,
            question: "How do I generate a report?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Reports item in the navigation menu`,
              `2. Select a Report Type from the Dropdown. This will take you to the Generate Report popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_report_menu}
                      alt="report menu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_generate_report_modal}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Select the Start and End date range for selected report .`,
              `4. Select the document type or desired format either in PDF or CSV.`,
              `5. Click GENERATE button to the report or CANCEL to discard the selection.`,
            ],
          },
        ],
      },
      {
        name: "assets",
        text: "Assets",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 7,
            question: "What types of assets can I monitor?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Boreholes`,
              `2. Generators`,
              `3. Lawn mowers`,
              `4. Vehicles`,
              `5. Furniture`,
              `6. Building`,
              `7. Computer Equipment`,
              `8. Desalination plant`,
              `9. Office equipment`,
              `10. Solar plant`,
              `11. Pumps`,
              `12. Meters`,
            ],
          },
          {
            questionID: 8,
            question: "How do you add an asset?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Maintenance item in the navigation menu.`,
              `2. Click on the Assets item on the dropdown. This will take you to the “Assets” page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_assets_menu}
                      alt="select menu assets "
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_assets}
                      alt="page assets"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click the ADD AN ASSET button on the right. This will take you to the “Add an Asset” popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_create_asset_modal}
                      alt="select menu assets "
                    />
                  </ResponsiveRow>
                );
              },
              `4. Populate the Asset details in the fields.`,
              // `5. There are a few special fields to take note of:`,
              () => {
                return (
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: "30px",
                      margin: { xs: "10px auto", lg: "20px auto" },
                      width: "90%",
                      // color: "#222",
                      fontWeight: 500,
                      textAlign: "start",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    <strong style={{ color: kodi_theme.palette.primary.dark }}>
                      Asset category:{" "}
                    </strong>{" "}
                    <br />
                    Let's you classify a vendor for better organization. There
                    are some pre-defined types, but you can add your owner by
                    selecting Other... <br />
                    <br />
                    <strong style={{ color: kodi_theme.palette.primary.dark }}>
                      Is this a metered Asset?
                    </strong>{" "}
                    <br />
                    It's important to select this field if the Assets are
                    metered for billing and charging purposes. <br />
                    <br />
                    <strong style={{ color: kodi_theme.palette.primary.dark }}>
                      {" "}
                      Does this asset require maintenance?{" "}
                    </strong>{" "}
                    <br />
                    It's important to select this field if the Asset requires
                    periodic maintenance for better performance. Doing so will
                    allow you to select a maintenance account, maintenance
                    period, te acquired, Purchase price and Current value of the
                    asset. <br />
                    <br />
                    <strong style={{ color: kodi_theme.palette.primary.dark }}>
                      {" "}
                      Does this asset generate income?
                    </strong>{" "}
                    <br />
                    It's important to select this field if the asset brings in
                    income. Doing so will allow you to select an income account
                    and record a purchase price as well as Current value It's
                    important to select this field if the vendor is a home
                    owners association. Doing so will allow you to select a
                    management company for the association. It also makes this
                    vendor available to select as the HOA when you create a
                    property.
                  </Typography>
                );
              },
              `6. Click SAVE to add the Asset details or CANCEL to leave the“Add Asset” modal.`,
            ],
          },
          {
            questionID: 9,
            question: "How do you record an assets meter reading?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals / Home item in the navigation menu`,
              `2. Scroll down and click on the Meters item on the dropdown. This will take you to the 'Meters' page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_meters_menu}
                      alt="meters menu"
                    />{" "}
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_meters_menu_hoa}
                      alt="meters menu hoa"
                    />
                  </ResponsiveRow>
                );
              },
              `2. Navigate to the assets table and click on the three-dots icon on the desired asset and click on the READINGS button. This will bring you to the Meter Readings popup modal`,
              `3. Click on the ADD READING button at the bottom of the modal. This will take you to the ADD METER READING popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_meters_add_meter_readings_modal}
                      alt="meters add meter reading modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Populate the reading details in the fields provided.`,
              `5. Click the ADD READING button to add the new reading, or the CANCEL button to cancel.`,
            ],
          },
          {
            questionID: 10,
            question: "How do you set the maintenance schedule for an asset?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Maintenance item in the navigation menu.`,
              `2. Click on the Assets item on the dropdown. This will take you to the “Assets” page. As shown in the Add an Asset tutorial.`,
              `3. On the desired asset row, click on the three-dot icon and click on the EDIT ASSET INFORMATION popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_assets_edit_maintenance_modal}
                      alt="assets edit maintenance modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Scroll down to the 'Does this assets require maintenance?' switch and turn it on (green means on, grey means off)`,
              `5. Set the maintenance schedule as required.`,
              `6. Click the UPDATE button to add the save the asset's changes, or the CANCEL button to cancel.`,
            ],
          },
        ],
      },
      {
        name: "ownership",
        text: "Ownership",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA"],
        data: [
          {
            questionID: 51,
            question: "Creating Ownerships",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. First, proxy to locate the facility.`,
              `2. From the Menu, Click on the Homes tab dropdown to display features under Homes category.`,
              `3. Click on the Ownerships tab. An ownership list view will be displayed as shown in the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownerships_list_view}
                      alt="ownerships list view"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Click the "ADD OWNERSHIP" button on the top-right corner. This will take you to the Ownership details page. (see image below)`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_details}
                      alt="ownership details"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `5. Select the start date of the ownership.`,
              `6. The facility field will show the facility that you are in so skip over to the "unit" field and select available units from the dropdown.`,
              `7. If there is an incoming balance, type in the amount and add incoming balance notes else leave it blank.`,
              `8. Proceed to the "Home Owners" section. Click "ADD HOME OWNER" button. This will prompt a pop up box where you can either choose a ‘company’ or ‘individual’ as homeowner.`,
              `9. If you select “company” you shall be required to search for the company to see if it exists in the system else proceed to creating one.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_company_search}
                      alt="ownership company search"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `10. If you select “individual” you shall be required to input the persons “ID Number” and select their “ID Type” for the system to search if the individual exists in the system else proceed to creating one.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_individual_search}
                      alt="ownership individual search"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `11. Click "YES" to proceed to creating Tenant, "NO" to go back to the Ownership details page.`,
              `12. Selecting Yes will prompt a user details pop up box. Populate the home owner details in the required fields (see image).`,
              `13. Click "CREATE USER" button to SAVE the home owner details. This will take you back to the ownership details. `,
              `15. On Ownership Charges section, click "ADD ROW" to create a charge.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_charge}
                      alt="ownership add charge"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      lineHeight: "30px",
                      margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                      color: "#333",
                      fontWeight: 500,
                      textAlign: "start",
                      whiteSpace: "pre-wrap",
                      paddingLeft: "20px"
                    }}
                  >
                    {`There are 4 types of charges involved when creating an ownership;
                      a. Capital Fund.
                      b. Service charge.
                      c. Utility-electricity charge .
                      d. Utility-water charge
                    `}
                  </Typography>
                );
              },
              () => {
                return (
                  <>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >Take note and populate the following:</Typography>
                    <ul style={{paddingLeft: "60px"}}>
                      <li><strong>Unit:</strong> This field will be automatically populated based on your selection in the first section.</li>
                      <li><strong>Charge Type:</strong> Select the account the charge is issued to from the drop down. (Service charge, Capital Fund, Utility-Electricity, Utility-Water)</li>
                      <li><strong>Amount:</strong> Input the charge amount.</li>
                      <li><strong>Billing period:</strong> Select option of billing frequency. (Monthly, Quarterly, Yearly)</li>
                      <li><strong>Invoice Date:</strong> The date the invoice will be issued based on the billing frequency selected.</li>
                      <li><strong>Apply tax:</strong> If the charge is to be taxed, ensure you select the toggle button. </li>
                    </ul>
                  </>
                )
              },
              `16. Click "CREATE" button to SAVE all sections of the home owner details. `
            ]
          },
          {
            questionID: 52,
            question: "Terminating Ownerships",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Ownerships tab and you should be presented with the Ownership List page`,
              `3. Select the ownership you would like to terminate by checking the checkbox (on the left edge of the page). Click the Action icon for the selected ownership and a list of action options will be dropped down similar to the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminate}
                      alt="ownership terminate"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Select the “Terminate” option and a screen similar to the image below shall be presented.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminate_confirm}
                      alt="ownership terminate confirm"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `5. Follow the instructions carefully and populate the details if applicable. Please ensure you’ve added all necessary charges if applicable by clicking the "ADD ROW" button.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminate_add_row}
                      alt="ownership terminate confirm add row"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `6. Click the "TERMINATE OWNERSHIP" button to terminate the selected ownership or the "CANCEL" button to go back to the ownership list page.`,
            ]
          },
          {
            questionID: 53,
            question: "Adding Notes",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Ownerships tab and you should be presented with the Ownership List page.`,
              `3. Select the ownership you would like to add in a note by checking the checkbox (on the left edge of the page). Click the Action icon for the selected ownership and a list of action options will be dropped down similar to the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_note}
                      alt="ownership add note"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Select the “Add Note” option and a screen similar to the image below shall be presented.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_note_input}
                      alt="ownership add note input"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `5. Type in the notes in the Notes field. Words will be limited to 500 words.`,
              `6. Click the "SAVE NOTE" button to save the notes typed in or the "CANCEL" button to go back to the ownership list page.`,
            ]
          },
          {
            questionID: 54,
            question: "Receiving Payment",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Ownerships tab and you should be presented with the Ownership List page.`,
              `3. Select the ownership you would like to make payment by checking the checkbox (on the left edge of the page). Click the Action icon for the selected ownership and a list of action options will be dropped down similar to the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_receive_payment}
                      alt="ownership receive payment"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Select the “Receive Payment” option and a screen similar to the image below shall be presented.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_receive_payment_modal}
                      alt="ownership receive payment_modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >Take note and populate the following:</Typography>
                    <ul style={{paddingLeft: "60px"}}>
                      <li><strong>Date:</strong> Select date in the Date field. Note that it is auto selected to show the current date.</li>
                      <li><strong>Payment Method:</strong> Select the payment method from the drop down. (Cash, Cheque, RTGS)</li>
                      <li><strong>Payment Invoice/Charge:</strong> Select the specific outstanding invoice or charge.</li>
                      <li><strong>Amount:</strong> Input the payment amount for the selected invoice/charge. Note that you can pay partially.</li>
                      <li><strong>Notes:</strong> Type in any notes related to the payment in this section.</li>
                    </ul>
                  </>
                )
              },
              `5. Click the "APPLY PAYMENT" button or the "CANCEL" button to go back to the ownership list page.
`
            ]
          },
          {
            questionID: 54,
            question: "Issuing Credit and Charges",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Ownerships tab and you should be presented with the Ownership List page`,
              `3. Select the ownership you would like to issue credit or charges by checking the checkbox (on the left edge of the page). Click the Action icon for the selected ownership and a list of action options will be dropped down similar to the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_issue_charge_credit}
                      alt="issue credit and charges"
                    />{" "}
                  </ResponsiveRow>
                );
              },
            ]
          }
        ]
      },
      {
        name: "terminated ownerships",
        text: "Terminated Ownerships",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA"],
        data: [
          {
            questionID: 55,
            question: "Viewing terminated ownerships",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Terminated Ownerships tab this will open the Terminated Ownership List page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminated_link}
                      alt="terminated ownerships link"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `3. Select the Terminated ownership you would like to view by checking the checkbox (on the left edge of the page). Click the Action icon for the selected ownership and a list of action options will be displayed.`,
              `4. Select View as shown in the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminated_view_button}
                      alt="terminated ownerships view button"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `5. This brings you to the ownership information page, with information on ownership charges, previously uploaded documents if any as well as transaction history. (See image below)`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_terminated_view}
                      alt="terminated ownerships view"
                    />{" "}
                  </ResponsiveRow>
                );
              },
            ]
          }
        ]
      },
      {
        name: "owners",
        text: "Owners",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA"],
        data: [
          {
            questionID: 56,
            question: "Editing home owner information",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Proxy to select the property.`,
              `2. Select Homes category dropdown from Menu -> Ownerships tab. This brings you to the Manage Home Owners List page.`,
              `3. To edit a home owner information, select Edit from the dropdown as shown by the arrow in the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_edit_homeowner_link}
                      alt="edit homeonwner link"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. The Edit user window shall pop up. Populate any new changes in the form fields. And activate permissions in the ‘Activate Permissions at this Property section.`,
              () => {
                return (
                  <ResponsiveRow>
                    <strong>Please note:</strong> Activating permission will make an owner a committee member for respective granted permission. That is the Capital Fund Committee or Budget Committee or Both.
                  </ResponsiveRow>
                )
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_edit_homeowner_modal}
                      alt="edit home owner modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `5. Click the "UPDATE" button to save the edits or the "CANCEL" button to go back to the Manage Home Owners list page.`,
            ]
          }
        ]
      },
      {
        name: "capital funds",
        text: "Capital Funds",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA"],
        data: [
          {
            questionID: 57,
            question: "Creating, editing a capital fund",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Click on the Capital Funds link on the left sidebar under Homes drop down.`,
              `2. After clicking the Capital Funds link you will be directed to the Capital Funds page where you can view all the Capital Funds, Export Capital Funds, Download Capital Funds as well as adding a new Capital Fund.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_capitalfund_buttons}
                      alt="capital fund buttons"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `3. To add a new Capital Fund click on the add button just above the Capital Funds list on the right side and fill in the capital fund form.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_capitalfund_modal}
                      alt="ownership capitalfund modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >To fill in the capital fund form, key in:</Typography>
                    <ul style={{paddingLeft: "60px"}}>
                      <li>Capital fund name - required.</li>
                      <li>Add a name description.</li>
                      <li>Select a Facility - required.</li>
                      <li>Add amount – required</li>
                      <li>Tick on Distribute evenly if you want the amount to be distributed evenly among homeowners - required.</li>
                      <li>Tick on Approval required if you need homeowners to approve the capital fund. You can be required to key in the approval threshold percentage on ticking the approval required.</li>
                      <li>Select a due date - required.</li>
                      <li>If distributed evenly is not selected, key in amount for each homeowner under the capital fund distribution section, otherwise it will be populated.</li>
                      <li>Click "SAVE" to create the capital fund or click "CANCEL" to quit the capital fund creation process. On successful creation it will appear on the list of capital fund.</li>
                    </ul>
                  </>
                )
              },
              `4. To View individual capital fund, click on the view link under the action column on the capital fund you want to view from the list.`,
              `5. To Edit individual capital fund, click on the edit link under the action column on the capital fund you want to edit from the list and repeat the process for capital fund creation.`,
              `6. To Delete individual capital fund, click on the delete link under the action column on the capital fund you want to delete from the list. Note: approved capital fund cannot be edited or deleted.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_capitalfund_actions}
                      alt="ownership capitalfund actions"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `7. To Export Capital Funds click on the Export Capital Fund button just above the Capital Funds list on the right side between the add and download capital fund button. Excel will be downloaded.`,
              `8. To Download Capital Funds click on the Download Capital Fund button just above the Capital Funds list on the right side. It will be disabled until you select the capital fund(s) to download.`,
              `9. To select capital funds to download, check the check box on the left outermost column of the capital fund list. After selecting (checking the capital funds you want to download on the list) the download capital fund button would be automatically activated. After clicking on the button, you will be needed to confirm export via mail since the process takes a while to complete. After confirming by clicking on the Export via Mail, the list of selected capital funds will be sent to your mail account.`,
            ]
          }
        ]
      },
      {
        name: "budgeting",
        text: "Budgeting",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA"],
        data: [
          {
            questionID: 58,
            question: "Adding a budget",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Select the facility. From the Menu, select Homes -> Budgeting tab. This shall display the Budgets List page.`,
              `2. To add a budget, click the "ADD BUDGET" button at as shown by the arrow in the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_budget_button}
                      alt="ownership add budget button"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `3. Clicking the Add button will direct you to the Budget details form.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_budget_modal}
                      alt="ownership add budget modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >To fill in the capital fund form, key in:</Typography>
                    <ul style={{paddingLeft: "60px"}}>
                      <li><strong>Name:</strong> Input the name of the budget. This is a required field.</li>
                      <li><strong>Description:</strong> Type in the description of the budget.</li>
                      <li><strong>Start date, End date</strong> From the calendar picker, select the start and end date for the period of the budget.</li>
                      <li><strong>Approval:</strong> If an approval from the committee is needed, check the ‘Approval required’ check box. This will prompt the Approval threshold (%) field. Input the max percentage that is required to have the budget approved by the committee.</li>
                      <li><strong>Notes:</strong> Type in any notes related to the payment in this section.</li>
                    </ul>
                  </>
                )
              },
              `5. There are two ways to create a budget, from the income or the expense account.`,
              `6. In order to input the monthly/income budget amount, select the ‘Income’ tab as shown by the arrow in the image below. Click on the Add Row button.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_ownership_add_budget_income}
                      alt="ownership add budget income"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `7. Select the month/income account from the drop down, and proceed to input the monthly amounts. The income total will be automatically calculated as you add in the amounts. The same goes for the Expense option.`,
              `8. Click the "SAVE" button to save the budget details or the "CANCEL" button to go back to the Budgets list page.`,
            ]
          }
        ]
      },
      {
        name: "leasing",
        text: "Leasing",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 12,
            question: "How do I create a lease?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals item in the navigation menu`,
              `2. Click on the Leases item on the dropdown. This will take you to the Leases page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_leases_menu}
                      alt="select lease submenu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_leases}
                      alt="leases page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click on the ADD LEASE button. This will take you to the Add Lease popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_create_lease_modal}
                      alt="select create lease modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Populate the lease details in the fields provided.`,
              `6. Click the CREATE button to add the lease, or the CLOSE button to cancel.`,
            ],
          },
          {
            questionID: 13,
            question: "How do I terminate a lease?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals item in the navigation menu`,
              `2. Click on the Leases item on the dropdown. This will take to the Leases page as shown in the Add a Lease tutorial`,
              `3. On the desired lease to terminate click on the three-dots icon and click on TERMINATE item. This is take you to the Terminate Lease popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_datagrids_leases_terminate}
                      alt="datagrid lease terminate"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_terminate_lease_modal}
                      alt="terminate leases modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Settle the lease balances using in the fields provided.`,
              `6. Click the TERMINAE LEASE button to terminate the lease, or the CANCEL button to cancel.`,
            ],
          },
          {
            questionID: 14,
            question: "How do I edit a lease?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals item in the navigation menu`,
              `2. Click on the Leases item on the dropdown. This will take to the Leases page as shown in the ADD a Lease tutorial`,
              `3. On the lease to terminate click on the three-dots icon and click on TERMINATE item. This is take you to the Terminate Lease popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_datagrids_leases_edit}
                      alt="datagrid lease edit"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_edit_lease_modal}
                      alt="edit leases modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Update the lese information as required using the provided fields.`,
              `6. Click the EDIT LEASE button to save the changes, or the CANCEL button to cancel.`,
            ],
          },
          {
            questionID: 16,
            question: "How do I edit a tenant’s information?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals item in the navigation menu`,
              `2. Click on the Tenant item on the dropdown. This will take to the Tenants page `,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_select_tenant_menu}
                      alt="select tenant menu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_tenant}
                      alt="terminate leases modal"
                    />
                  </ResponsiveRow>
                );
              },
              `3. On the desired lease to edit click on the three-dots icon and click on EDIT item. This is take you to the Edit User popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_datagrid_tenant_edit}
                      alt="datagrid edit tenant"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_edit_tenant_modal}
                      alt="edit tenant modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Click the SAVE button to update the Tenant’s details or CANCEL to discard the changes.`,
            ],
          },
          {
            questionID: 17,
            question: "How do I save a scanned lease or other lease documents?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Rentals item in the navigation menu`,
              `2. Click on the Leases item on the dropdown. This will take to the Leases page as shown in the Add a Lease tutorial`,
              `3. On the desired lease click on the three-dots icon and click on VIEW item. This is take you to the Lease Details page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_datagrid_lease_view}
                      alt="select tenant menu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_lease_detail_page}
                      alt="terminate leases modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Scroll down to the Documents card and click on SELECT to select the desired documents. Please note there is a 10MB file limit`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_card_lease_document}
                      alt="card lease document"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Once you've selected the required files, click on UPLOAD to save them. The document will appear below once successfully uploaded.`,
            ],
          },
        ],
      },
      {
        name: "messages",
        text: "Messages",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 18,
            question: "What types of messages can I send?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Phone SMS`,
              `2. Tenant App message`,
              `3. Bulk messages`,
              `4. Individual messages`,
            ],
          },
          {
            questionID: 19,
            question: "How do I send an SMS to a tenants phone number?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Messages item in the navigation menu`,
              `2. This will take you to the Messages page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_messages_menu}
                      alt="select messages submenu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_messages}
                      alt="messages page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. From the left hand-side panel, click on the NEW MESSAGE  button. This will load the New Message form.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_form_messages_create}
                      alt="form messages create"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Be sure to give the SMS a subject and write the message you wish to relay to your tenants.`,
              `   Please note: You can send a bulk message by selecting multiple recipients in the Message Recipients dropdown input.`,
              `5. Please ensure you have selected the check box, else the message shall be sent to the Tenant App.`,
              `6. Click the SEND MESSAGE button to Send out the SMS composed to the selected Tenants or Trash icon on the top right corner to discard the message`,
              `6. Click the SEND MESSAGE button to Send out the SMS composed to the selected Tenants or Trash icon on the top right corner to discard the message`,
            ],
          },
          {
            questionID: 20,
            question: "How do I send a message to the tenant app?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. From the Menu, Click on the Messages Tab. This brings you to the Message page where you will view recently sent and received messages.`,
              `2. From the Menu column in the Message page, select button. This will prompt the “Send Message” form page.`,
              `3. From the send message form, you can either choose to send SMS to all Tenants by checking the “Select All Tenants” checkbox, or Select individual Tenants from the “To” dropdown field.`,
              `4. Avoid selecting check box, else the message shall be as an SMS to the Tenant.`,
              `5. Click the button to Send out the message composed to the selected Tenants App.`,
            ],
          },
        ],
      },
      {
        name: "systemUsers",
        text: "System Users",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 22,
            question: "What are the user roles in the system?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `Building Director`,
              `Building Manager`,
              `Accountant`,
              `Clerk`,
              `Reception`,
            ],
          },
          {
            questionID: 23,
            question: "Which permissions does each role have?",
            hasSubAnswers: true,
            hasSteps: false,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            subAnswers: [
              {
                header: "System Admin",
                steps: [
                  `Dashboard`,
                  `Manage companies`,
                  `Subscriptions`,
                  `Billing Services`,
                  `Mobile money`,
                  `Manage users`,
                  `Send messages`,
                  `Manage properties, leases, terminated leases, tenants, owners and utilities`,
                  `Manage work orders and approve`,
                  `Manage Assets`,
                  `Manage inventories`,
                  `Manage vendors`,
                  `Manage invoices`,
                  `Manage Bills and Payments`,
                  `Manage receipts`,
                  `Manage Journal entries`,
                  `Manage reconciliations`,
                  `Bank accounts and Transfers`,
                  `Chart of Accounts`,
                ],
              },
              {
                header: "Building Director",
                steps: [
                  `Dashboard`,
                  `Manage users`,
                  `Send messages`,
                  `Manage properties, leases, terminated leases, tenants, owners and utilities`,
                  `Manage work orders and approve`,
                  `Manage Assets`,
                  `Manage inventories`,
                  `Manage vendors`,
                  `Manage invoices`,
                  `Manage Bills and Payments`,
                  `Manage receipts`,
                  `Manage Journal entries`,
                  `Manage reconciliations`,
                  `Bank accounts and Transfers`,
                  `Chart of Accounts`,
                ],
              },
              {
                header: "Building Manager",
                steps: [
                  `Dashboard`,
                  `Manage users`,
                  `Send messages`,
                  `Manage properties, leases, terminated leases, tenants, owners and utilities`,
                  `Manage work orders and approve`,
                  `Manage Assets`,
                  `Manage inventories`,
                  `Manage vendors`,
                  `Manage receipts`,
                  `Manage Journal entries`,
                ],
              },
              {
                header: "Accountant",
                steps: [
                  `Dashboard`,
                  `Manage invoices`,
                  `Manage Bills and Payments`,
                  `Manage receipts`,
                  `Manage Journal entries`,
                  `Manage reconciliations`,
                  `Chart of Accounts`,
                ],
              },
              {
                header: "Clerk",
                steps: [`Record meter readings`],
              },
              {
                header: "Reception",
                steps: [`Issue receipts`],
              },
            ],
          },
          {
            questionID: 24,
            question: "How do I add a user?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Manage User item in the navigation menu`,
              `2. This will take you to the Manage Users page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_select_user_menu}
                      alt="select user menu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_user}
                      alt="page user"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click on the ADD USER button. This will take you to the Individual/Organization Search popup modal.`,
              `4. Enter the new user's ID number and type to check if they already exist in the system. Click on SEARCH to execute the search`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_personOrg_search_modal}
                      alt="person org search modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. If the user exists, they're name will appear on the found users list. Clicking on their name will take you to the Add User popup modal`,
              `6. The system will preload the user's information and provide a Role dropdown input for you to select the role you'd like to assign the user.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_personOrg_search_results_modal}
                      alt="person org search results modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_user_pre_populated_modal}
                      alt="add user pre-populated modal"
                    />
                  </ResponsiveRow>
                );
              },
              `7. If the user does not exists, a no individuals found dialogue will appear asking if you'd like to create the user`,
              `8. Clicking on YES will take you to the Add User popup modal. Click on NO will close the popup modal`,
              `9. Upon clicking YES, the system will preload the user's ID number and type provided earlier. you can then populate the user details in the fields as required.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_personOrg_search_no_results_modal}
                      alt="person org search no results modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_user_modal}
                      alt="add user modal"
                    />
                  </ResponsiveRow>
                );
              },
              `10. Click CREATE to add the user or CANCEL to close the popup modal.`,
            ],
          },
          {
            questionID: 25,
            question: "How do I edit a user?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Manage User item in the navigation menu`,
              `2. This will take you to the Manage Users page as shown in the Add a User tutorial`,
              `3. Click on the EDIT button of the user you'd like to edit. This will take you to the Edit User popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_card_user_edit}
                      alt="edit user card"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_edit_user_modal}
                      alt="edit user modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Edit the User’s information in the form fields.`,
              `5. Click the UPDATE button to update the user’s details or CANCEL to close the popup modal.`,
            ],
          },
          {
            questionID: 26,
            question: "How do I remove a user?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Manage User item in the navigation menu`,
              `2. This will take you to the Manage Users page as shown in the Add a User tutorial`,
              `3. Click on the DELETE button of the user you'd like to delete. This will take you to the Delete Confirmation popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_card_user_delete}
                      alt="delete user card"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_delete_user_modal}
                      alt="eddeleteit user modal"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click the YES button to delete the user or CANCEL to close the popup.`,
            ],
          },
        ],
      },
      {
        name: "utilities",
        text: "Utilities",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 27,
            question: "What are the different types of meters?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Electricity – Unit`,
              `2. Municipal Electricity - Property`,
              `3. Municipal Water - Property`,
              `4. On-site Electricity – Property`,
              `5. Water - Unit`,
              `6. Prepaid Electricity - Unit`,
              `7. Other`,
            ],
          },
          {
            questionID: 28,
            question: "How do I add a meter?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Homes / Rentals item in the navigation menu`,
              `2. Click on the Meters item on the dropdown. This will take you to the Meters page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_select_meter_menu}
                      alt="select meter submenu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_select_meter_menu_hoa}
                      alt="select meters submenu hoa"
                    />{" "}
                  </ResponsiveRow>
                );
              },

              `3. Click on the ADD METER button. This will take you to the Add Meter popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_meter}
                      alt="select meters submenu hoa"
                    />{" "}
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_meter_add_modal}
                      alt="add smeter modal"
                    />{" "}
                  </ResponsiveRow>
                );
              },

              () => {
                return (
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: "30px",
                      margin: "10px auto 20px auto",

                      textAlign: "start",
                      whiteSpace: "pre-wrap",

                      width: "80%",
                    }}
                  >
                    <strong>Take note of the following fields:</strong>
                    <br />
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      Meter Reading Frequency Dropdown:
                    </span>
                    <br />
                    There are three options to choose from. You could either
                    collect meter readings{" "}
                    <strong>Daily, Weekly or Monthly</strong>. <br />
                    <br />{" "}
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      Meter Type (Dropdown)
                    </span>
                    <br />
                    There are several types of meters. If the meter category
                    isn’t listed, select “Other” <br />
                    <br />
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      Does this asset require maintenance?
                    </span>
                    <br />
                    It’s important to select this field if the Asset requires
                    periodic maintenance for better performance. Doing so will
                    allow you to select a maintenance account, maintenance
                    period, the acquired, purchase price and the current value
                    of the asset.
                    <br />
                    <br />
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      {" "}
                      Attach to a property/unit{" "}
                    </span>{" "}
                    <br />- If the meter belongs to a Property/Unit, select the{" "}
                    <strong>Facility</strong> option and then select the desired
                    facility item from the dropdown field that appears. <br />-
                    If the meter belongs to a complex, select the{" "}
                    <strong>Complex</strong> option. Select the desired complex
                    item from the dropdown field that appears. <br />
                    <br />
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      {" "}
                      Is this meter invoiced to the unit tenant?{" "}
                    </span>
                    <br />
                    It’s important to select this field if the meter charges are
                    invoiced to the tenant whose unit is attached to the
                    specific meter rate. It’s important to indicate the meter
                    rate in <strong>KES</strong>
                  </Typography>
                );
              },

              `4. Fill in the required details in the provided fields.`,
              `5. Click CREATE to add the Meter details or CANCEL to close the popup modal.`,
            ],
          },
          {
            questionID: 29,
            question: "How do I edit a meter?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Homes / Rentals item in the navigation menu`,
              `2. Click on the Meters item on the dropdown. This will take you to the Meters page, as shown in the Add a Meter tutorial`,
              `3. Click on the three-dots icon of the desired meter and click on the Edit item. This will bring you to the Edit Meter popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_datagrid_meter_edit}
                      alt="select datagrid_meter_edit submenu"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_meter_edit_modal}
                      alt="select meters submenu hoa"
                    />{" "}
                  </ResponsiveRow>
                );
              },
              `4. Click the UPDATE button to update the meter's details or CANCEL to close the popup modal.`,
            ],
          },
          {
            //   questionID: 30,
            //   question: "How do I assign standing charges to a meter?",
            //   hasSubAnswers: false,
            //   hasSteps: true,
            //   permitted: "BLDIR,BLDMG,REC,ACC,CS",
            //   steps: [
            //     `1. Navigate to the Meter you would want to add a “standing charge” or Add a new meter.`,
            //     `2. From the “Edit Meter” form page, navigate to the “standing charge” field (See below image) Use the tiny arrows on the right to increase or decrease the standing charge number.`,
            //   ],
          },
        ],
      },
      {
        name: "utilitiesApp",
        text: "Utilities App",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 31,
            question: "How do I download the “SmartKodi Meter” App?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Open the Google Play Store: Locate and tap the Play Store icon on your Android device to launch the application.`,
              `2. Search for SmartKodi Meter: In the search bar at the top, type "SmartKodi Meter" and press enter.`,
              () => {
                return (
                  <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >3. Select the App: From the search results, find and tap on "SmartKodi Meter" developed by Villasoft. <a href="https://play.google.com/store/apps/details?hl=id&id=com.smartkodimeter&utm_source=chatgpt.com">​Android Apps on Google Play</a></Typography>
                )
              },
              `4. Install the App: On the app's page, tap the "Install" button to begin downloading and installing the application.`,
              () => {
                return (
                  <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "30px",
                        margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                        color: "#333",
                        fontWeight: 500,
                        textAlign: "start",
                        whiteSpace: "pre-wrap",
                        paddingLeft: "20px"
                      }}
                    >4. Open the App: Once installation is complete, tap "Open" to launch SmartKodi Meter. <a href="https://play.google.com/store/apps/details?hl=id&id=com.smartkodimeter&utm_source=chatgpt.com">​Android Apps on Google Play</a></Typography>
                )
              },

            ],
          },

          {
            questionID: 59,
            question: "How do I Login?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Log in to the SmartKodi Meter app using your username and password. (See Image below)`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={login_utilies_app}
                      alt="login to meter app"
                    />
                  </Box>
                );
              },
              `2. Once logged in, a landing page shall be presented. (See image below)`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={landing_utilies_app}
                      alt="landing to meter app"
                    />
                  </Box>
                );
              },
              `3. Tap on either the Water or Electricity tab to view a list of meter readings available to you.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={tabs_utilies_app}
                      alt="tabs to meter app"
                    />
                  </Box>
                );
              },
            ]
          },
          {
            questionID: 32,
            question: "How do I record a meter reading?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. From the list of meters displayed, tap on the meter you want to record a reading for.`,
              `2. Tap the "Add Reading" button.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={add_reading_utilies_app}
                      alt="add reading to meter app"
                    />
                  </Box>
                );
              },
              `3. Type the new meter reading value into the "Enter New Reading" field.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={enter_reading_utilies_app}
                      alt="enter reading to meter app"
                    />
                  </Box>
                );
              },
              `4. Tap the "Capture Photo" button to take a picture of the meter display.`,
              `5. Tap "Save" to record and store the meter reading or “Cancel” to discard the reading.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={save_reading_utilies_app}
                      alt="save reading to meter app"
                    />
                  </Box>
                );
              },
            ]
          },
          {
            questionID: 60,
            question: "How do I search or sort meters?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Tap the "See All Meters" button to view the full list.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={see_all_meters_utilies_app}
                      alt="see all meters"
                    />
                  </Box>
                );
              },
              `2. Tap on the search bar and type in the unit name or meter name.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={search_meters_utilies_app}
                      alt="search meters"
                    />
                  </Box>
                );
              },
              `3. To sort, tap the icon next to the search bar—this will display all available sorting options such as by meter or unit name in ascending or descending (A-Z / Z-A).`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={sort_meters_utilies_app}
                      alt="search meters"
                    />
                  </Box>
                );
              },

            ],
          },
          {
            questionID: 33,
            question: "How do I Report a Broken Meter?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Select either the “Water” or “Electricity” Meter tab from the landing page.`,
              `2. From the list of meters displayed, tap on the meter you wish to report.`,
              `3. Tap the "Report Broken" button.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={report_broken_meter_utilities_app}
                      alt="record a meter as broken"
                    />
                  </Box>
                );
              },
              `3. A confirmation pop-up will appear with two options: "Cancel" or "Report". Tap "Report" to proceed. Tap "Cancel" to exit without reporting.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={confirm_report_broken_meter_utilies_app}
                      alt="record a meter as broken 2"
                    />
                  </Box>
                );
              },
              `4. Select Report to alert the Meter as broken or Cancel to discard the alert.`,
              `Note: Once a meter is reported as broken, it will no longer appear in the SmartKodi Meter app.`
            ],
          },
            {
              questionID: 61,
              question: "Offline Mode – Record Readings Without Internet",
              hasSubAnswers: false,
              hasSteps: true,
              permitted: "BLDIR,BLDMG,REC,ACC,CS",
              steps: [
                () => {
                  return (
                    <>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          lineHeight: "30px",
                          margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                          color: "#333",
                          fontWeight: 500,
                          textAlign: "start",
                          whiteSpace: "pre-wrap",
                          paddingLeft: "20px"
                        }}
                        >To use offline mode:</Typography>
                      <ul style={{paddingLeft: "60px"}}>
                        <li> First, log in to the app while you have an internet connection.</li>
                        <li> Once logged in and without an internet connection; Proceed to record readings as usual using the steps above..</li>
                      </ul>
                    </>
                  )
                },
                () => {
                  return (
                    <>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          lineHeight: "30px",
                          margin: { xs: "10px auto", lg: "0px 0 5px 5px" },
                          color: "#333",
                          fontWeight: 500,
                          textAlign: "start",
                          whiteSpace: "pre-wrap",
                          paddingLeft: "20px"
                        }}
                        >What happens next:</Typography>
                      <ul style={{paddingLeft: "60px"}}>
                        <li>All readings recorded while offline will be marked as unsynced. </li>
                        <li> The app’s dashboard will show the total number of unsynced meters.</li>
                        <li>Once internet connectivity is restored, readings will automatically start syncing in the background.</li>
                      </ul>
                    </>
                  )
                },
                () => {
                  return (
                    <Box
                      sx={{
                        margin: "10px auto",
                        width: { xs: "100%", lg: "80%" },
                        padding: "10px",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: "100%",
                          objectFit: "contain",
                          objectPosition: "center",
                        }}
                        src={offline_mode_utilities_app}
                        alt="offline mode unsynced"
                      />
                    </Box>
                  );
                },
                () => {
                  return (
                    <Box
                      sx={{
                        margin: "10px auto",
                        width: { xs: "100%", lg: "80%" },
                        padding: "10px",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: "100%",
                          objectFit: "contain",
                          objectPosition: "center",
                        }}
                        src={offline_mode_syncing_utilities_app}
                        alt="offline mode syncing"
                      />
                    </Box>
                  );
                },
                
              ]
            }
        ],
      },
      {
        name: "accounting",
        text: "Accounting",
        permitted: "BLDIR,BLDMG,REC,ACC,CS,OWN",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 34,
            question: "How do I find an invoice?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Transactions from the Dropdown and choose Invoices. This will take you to the Invoices page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_faq_receipt_nav_4}
                      alt="Steps 1 & 2: Navigation to Invoices page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. If you remember the invoice details, fill them into the Invoice Search form and click Search to filter, or click Show All Invoices to browse available invoices.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_invoice_search}
                      alt="Step 3: Invoice Search Form"
                    />
                  </ResponsiveRow>
                );
              },
              `4. This will take you to the Invoices Table for further actions on the desired invoice.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_invoice_table}
                      alt="Step 4: Invoices Table"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 35,
            question: "How do I find a receipt?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Transactions from the Dropdown and choose Receipts. This will take you to the Receipts page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_faq_receipt_nav_4}
                      alt="Steps 1 & 2: Navigation to Receipts page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. If you remember the receipt details, fill them into the Receipt Search form and click Search to filter, or click Show All Receipts to browse available receipts.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_receipt_search_1}
                      alt="Step 3: Receipt Search Form"
                    />
                  </ResponsiveRow>
                );
              },
              `4. This will take you to the Receipts Table for further actions on the desired receipts.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_receipt_table}
                      alt="Step 4: Receipts Table"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 36,
            question: "How do I void a receipt?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Transactions from the Dropdown and choose Receipts. This will take you to the Receipts page.`,
              `3. Use the Receipt Search form to find the desired receipt or click Show All Receipts to go to the Receipts Table.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_receipt_search_1}
                      alt="Step 3: Receipt Search Form"
                    />
                  </ResponsiveRow>
                );
              },
              `4. On the desired receipt, click the three-dot icon and select VOID RECEIPT. This will open the Create Receipt Charge popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_receipt_charge_modal}
                      alt="Step 4: Create a Charge popup modal"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 39,
            question: "How do I create a bill?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Bill & Payments from the Dropdown. This will take you to the Bills & Payments page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bills_payment_1}
                      alt="Steps 1 & 2: Navigation to Bills & Payments page"
                    />

                  <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bills_payment_2}
                      alt="Steps 1 & 2: Navigation to Bills & Payments page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click the ADD BILL button. This will open the Create New Bill popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_add_bills_modal}
                      alt="Step 3: Bills & Payments page with ADD BILL button"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Fill in the necessary details.`,
              `5. Click SAVE to issue the bill or Cancel to close the modal.`,
            ],
          },
          {
            questionID: 62,
            question: "How do I pay a bill?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Bill & Payments from the Dropdown. This will take you to the Bills & Payments page.`,
              `3. Click on the Payments item at the top of the card to switch to the Payments tab view.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_payments_tabbed_view}
                      alt="Step 3: Payments tab view with MAKE PAYMENT button"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Click the Make Payment button. This will open the Make Payment popup modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_make_payment_modal}
                      alt="Step 4: Make Payment popup modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Populate the Payment information and click SAVE.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_populate_payment_info}
                      alt="Step 5: Populate Payment information"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 63,
            question: "How do I manage bank accounts?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Bank Accounts from the Dropdown to view or manage bank accounts.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bank_accounts}
                      alt="Steps 1 & 2: Navigation to Bank Accounts"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Use the Bank Accounts section to view details or click ADD BANK ACCOUNT to add a new account.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bank_accounts_view_add}
                      alt="Step 3: Bank Accounts section with ADD BANK ACCOUNT button"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 69,
            question: "How do I perform bank reconciliation?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Bank Accounts from the Dropdown. This will take you to the Bank Accounts page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bank_accounts}
                      alt="Steps 1 & 2: Navigation to Bank Accounts"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click the Reconciliation tab to access the Reconciliation section.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_reconciliation}
                      alt="Step 3: Reconciliation tab with ADD RECONCILIATION ITEM button"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Click the "Add Reconciliation Item" button to open the Reconciliation modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_add_reconciliation}
                      alt="Step 4: ADD RECONCILIATION ITEM button highlighted"
                    />
                  </ResponsiveRow>
                );
              },
              `5. Select an account to reconcile from the "Select Account" dropdown, enter the Start Date, Statement Date, Beginning Balance, and Ending Balance from your account statement, and add any bank service charges or interest earned by selecting "Type," entering the "Date" and "Amount," then clicking "Add Row" as needed.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_add_reconciliation_row}
                      alt="Step 5: Reconciliation modal with form fields and ADD ROW button"
                    />
                  </ResponsiveRow>
                );
              },
              `6. Review the details and click "Proceed/Continue" to save the reconciliation, or "Cancel" to discard changes.`,
            ],
          },
          {
            questionID: 65,
            question: "How do I make a cash to bank transfer?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu.`,
              `2. Select Bank Accounts from the Dropdown. This will take you to the Bank Accounts page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bank_accounts}
                      alt="Steps 1 & 2: Navigation to Bank Accounts"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click the Bank Transfers tab to access the Bank Transfers section.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_bank_transfers}
                      alt="Step 3: Bank Transfers tab with MAKE TRANSFER button"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Click the "Make Transfer" button to add a new transfer, which will open the Cash to Bank Transfer Details modal.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_make_transfer_button}
                      alt="Step 4: MAKE TRANSFER button"
                    />
                  </ResponsiveRow>
                );
              },
              `5. In the modal, select the "From Account" and "To Bank Account" from the dropdowns, enter a memo, and click "Save" to complete the transfer or "Cancel" to discard changes.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_cash_to_bank_transfer_details}
                      alt="Steps 4 & 5: Cash to Bank Transfer Details modal"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 46,
            question: "How do I check my transaction history?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              "Yes",
              '1. Navigate to "My Homes"',
              '2. Select the home click "View"',
              '3. Scroll down to the transaction history section.',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={transaction_history}
                      alt="Transaction History"
                    />
                  </ResponsiveRow>
                )
              },
              '4. Click "Load More Items" to view older transactions.',
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={load_more_transactions}
                      alt="Load more transactions"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 47,
            question: "Can I review and approve capital funds as a committee member?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              `Navigate to the Dashboard, on the ‘Home Owners Pending Approvals’ panel and click on the 3-dot menu to review and approve capital funds.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={home_owners_capital_fund_approval}
                      alt="Home owners capital fund approval"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
          {
            questionID: 66,
            question: "How do I manage journal entries and charts of accounts?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu`,
              `2. Select J.E. & Chart of Accounts from the Dropdown. This will take you to the combined Journal Entries and Charts of Accounts page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_journal_entries_nav}
                      alt="journal entries navigation"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Use the interface to manage entries or view account charts.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_manage_view_entries}
                      alt="manage or view entries"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 67,
            question: "How do I handle petty cash?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu`,
              `2. Select Petty Cash from the Dropdown. This will take you to the Petty Cash page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_petty_cash_nav}
                      alt="petty cash navigation"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Use the options to perform petty cash top-ups or generate petty cash reports.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_petty_cash_top_ups}
                      alt="petty cash top ups"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 68,
            question: "How do I manage VAT and withholding taxes?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu`,
              `2. Select Tax Payments from the Dropdown. This will take you to the Tax Payments page, where you can view the Taxes Payments section displaying total VAT to be paid, VAT, total withholding tax to be paid, and withholding tax credit.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_taxes_nav}
                      alt="taxes navigation"
                    />

                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_taxes_1}
                      alt="taxes page"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click "Add New Voucher" to open the Add Tax Voucher Payment modal.`,
              `4. In the modal, select the appropriate Tax Type (e.g., VAT or Withholding), enter the Payment Method, PRN Number, and Amount to Pay, optionally attach a payment slip, and click "Add Tax Payment" to save or "Cancel" to discard.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_taxes_add_payments}
                      alt="add tax payments"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            questionID: 70,
            question: "How do I manage credit notes and debit notes?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Accounting item in the navigation menu`,
              `2. Select Transactions from the Dropdown. This will take you to the Transactions page where you can choose between Credit Notes tab or Debit Notes tab.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_faq_receipt_nav_4}
                      alt="transactions navigation"
                    />
                  </ResponsiveRow>
                );
              },
              `3. For the desired type (Credit Notes or Debit Notes), if you remember the details, fill them into the respective Search form and click Search to filter, or click Show All [Type] (e.g., Show All Credit Notes) to browse available entries.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_credit_note}
                      alt="credit notes search forms"
                    />

                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_debit_note}
                      alt="debit notes search forms"
                    />
                  </ResponsiveRow>
                );
              },
              `4. This will take you to the respective table (e.g., Credit Notes Table, Debit Notes Table) where you can perform actions by clicking the three-dot icon on the desired entry and selecting the appropriate action.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_credit_note_table}
                      alt="credit notes tables"
                    />

                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_accounting_debit_note_table}
                      alt="debit notes tables"
                    />
                  </ResponsiveRow>
                );
              },
            ],
          },
        ],
      },
      {
        name: "tenantManagement",
        text: "Tenant Management",
        permitted: "OWN",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 48,
            question: "How can I manage my tenants?",
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            permitted: "OWN",
            steps: [
              `Click on "My Tenants" to view and edit tenant details.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={view_ownership_tenants}
                      alt="View ownership tenants"
                    />
                  </ResponsiveRow>
                )
              },
            ]
          },
        ]
      },
      {
        name: "maintenance",
        text: "Maintenance",
        permitted: "BLDIR,BLDMG,REC,ACC,CS",
        services: ["HOA", "CORE", "PREMIUM", "BLWTR", "METER", "MAINT", "LEAN"],
        data: [
          {
            questionID: 40,
            question: "How do I create a work order?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Maintenance item in the navigation menu`,
              `2. Select the work Orders item from the Dropdown. This will take you to the Work Order page`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_menu_work_order}
                      alt="generate report modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_work_order}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Fill in the fields provided to with the necessary details.`,
              `4. Click the CREATE button to submit the request or Cancel button to close the popup modal.`,
              `5. Take note: Once a work order has been created, the Building director has to approve first before the actual process.`,
            ],
          },
          {
            questionID: 41,
            question: "How do I edit a work order?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Maintenance item in the navigation menu`,
              `2. Select the Work Orders item from the Dropdown. This will take you to the Work Order page as shown in the Create a Work Order tutorial`,
              () => {
                return (
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: "30px",

                      margin: { xs: "10px auto", lg: "10px auto" },
                      width: "90%",

                      textAlign: "start",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      Take note: A work order can be edited
                    </span>
                    <br /> - in terms of adding a new charge, creating new notes
                    or uploading documents <br /> - if the it is at the
                    Requested (awaiting approval) or Pending (approved but not
                    started) stage
                  </Typography>
                );
              },
              `3. On the desired work order row, click on the three-dot icon and click on the EDIT WORK ORDER item. This will take you to the Edit Work Order popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_datagrid_work_order_edit}
                      alt="generate report modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_work_order_edit_modal}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Edit the work order request as required. Click on the UPDATE button to save the work order changes or CANCEL to close the popup modal.`,
            ],
          },
          {
            questionID: 42,
            question: "How do I add a vendor?",
            hasSubAnswers: false,
            hasSteps: true,
            permitted: "BLDIR,BLDMG,REC,ACC,CS",
            steps: [
              `1. Once logged in, click on the Maintenance item in the navigation menu`,
              `2. Select the Vendors item from the Dropdown. This will take you to the Vendor page.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_menu_vendor}
                      alt="generate report modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_page_vendors}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `3. Click on the ADD VENDOR button. This will take you to the Search Individual/Organization popup modal.`,
              () => {
                return (
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: "30px",

                      margin: { xs: "10px auto", lg: "10px auto" },
                      width: "90%",

                      textAlign: "start",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    <span
                      style={{
                        color: kodi_theme.palette.primary.dark,
                        fontWeight: 700,
                      }}
                    >
                      Take note: A vendor can either an individual or a
                      organization/company
                    </span>
                  </Typography>
                );
              },
              `4. Enter the new vendor's ID type and number (if the vendor is an individual) or company's name (if the vendor is a organization) to check if they already exist in the system. Click on SEARCH to execute the search`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_vendor_results_modal}
                      alt="generate report modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_vendor_no_results_modal}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `5. If the vendor exists, they're name will appear on the found user list. Clicking on their name will take you to the Add Vendor popup modal`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_vendor_add_vendor_modal}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `4. Enter the new vendor's ID number and type to check if they already exist in the system. Click on SEARCH to execute the search.`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "80%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={add_a_vendor}
                      alt="add a vendor"
                    />
                  </Box>
                );
              },
              `3. Click SAVE button to add the Vendor as company or CANCEL to discard the information.`,
              `4. If you select “Individual” you shall be required to input the persons “ID Number” and select their “ID Type” from the dropdown field in order for the system to search the individual in the system else if not found proceed to creating one.`,
              `5. Click button. This shall display the Vendor details” form as shown in the image below.`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_vendor_individual_modal}
                      alt="generate report modal"
                    />
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={new_ui_add_vendor_company_modal}
                      alt="generate report modal"
                    />
                  </ResponsiveRow>
                );
              },
              `6. Populate the fields with the required details.`,
              `7. Click the SAVE button to add the Vendor or the CANCEL button to close the popup modal.`,
            ],
          },
          // {
          //   questionID: 43,
          //   question: "How do I pay a vendor?",
          //   hasSubAnswers: false,
          //   hasSteps: true,
          //   permitted: "BLDIR,BLDMG,REC,ACC,CS",
          //   steps: [
          //     `1. Select Assets category dropdown from Menu -> Work Orders and you should be presented with the Work orders (In progress) page.`,
          //     `2. Click the View button in line with the Work order. This will display the Work order information form page.`,
          //     () => {
          //       return (
          //         <Box
          //           sx={{
          //             margin: "10px auto",
          //             width: { xs: "100%", lg: "80%" },
          //             padding: "10px",
          //           }}
          //         >
          //           <img
          //             style={{
          //               maxWidth: "100%",
          //               objectFit: "contain",
          //               objectPosition: "center",
          //             }}
          //             src={pay_a_vendor}
          //             alt="pay a vendor"
          //           />
          //         </Box>
          //       );
          //     },
          //     `3. To Add a Issue a payment to the Vendor, click on the button. An “Issue Payment Voucher to Vendor” form page will be prompted.`,
          //     () => {
          //       return (
          //         <Box
          //           sx={{
          //             margin: "10px auto",
          //             width: { xs: "100%", lg: "80%" },
          //             padding: "10px",
          //           }}
          //         >
          //           <img
          //             style={{
          //               maxWidth: "100%",
          //               objectFit: "contain",
          //               objectPosition: "center",
          //             }}
          //             src={pay_a_vendor_2}
          //             alt="pay a vendor_2"
          //           />
          //         </Box>
          //       );
          //     },
          //     `4. Select the vendor to whom the payment is to issued. Populate the rest of the information as described in the fields.`,
          //     `5. Click button to issue the payment to the vendor..`,
          //   ],
          // },
        ],
      },
    ];
  }

  getFAQData(role, userServices) {
    const data = [];
    this.faqData.forEach( item => {
      const permittedArr = item.permitted.split(",")
      const hasRole = permittedArr.includes(role)
      const hasService = userServices.some(value => item.services.includes(value))
      if(hasRole && hasService) {
        data.push(item)
      }
    })
    return data
  }

  mapQuestionsToArray(role) {
    const questionsArray = [];
    let count = 0;
    this.faqData.forEach((data) => {
      // only proceed if the role is included in the permitted 
      const permittedArr = data.permitted.split(",")
      
      if(permittedArr.includes(role)) {
        return data.data.forEach((question_item) => {
          count++;
          questionsArray.push({
            id: count,
            label: question_item.question,
            section: data.name,
          });
        });
      }
    });

    return questionsArray;
  }
}
